import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin } from 'lucide-react';
import { contentAPI } from '@/utils/api';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await contentAPI.getLLPDetails();
        setContactInfo(res.data);
      } catch (err) {
        console.error('Footer failed to load contact info', err);
      }
    };
    load();
  }, []);

  return (
    <footer data-testid="main-footer" className="bg-[#06101a] border-t border-white/5">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center justify-start">
              <img 
                src="/kapish-logo.png" 
                alt="KAPISH Corporate Resolution LLP" 
                className="h-32 w-auto"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-white text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.industries')}
                </Link>
              </li>
              <li>
                <Link to="/working-model" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.working_model')}
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.legal')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-secondary text-sm transition-colors">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-heading font-semibold text-white text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 text-sm">Corporate Debt Recovery</li>
              <li className="text-gray-400 text-sm">NPA Resolution</li>
              <li className="text-gray-400 text-sm">Financial Restructuring</li>
              <li className="text-gray-400 text-sm">Legal Coordination</li>
              <li className="text-gray-400 text-sm">Banking & Finance Facilitation</li>
              <li className="text-gray-400 text-sm">Asset Tracing & Valuation</li>
              <li className="text-gray-400 text-sm">Infra. & Project Consultancy</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-white text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-secondary mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{contactInfo?.email || 'contact@kapish.com'}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={16} className="text-secondary mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{contactInfo?.phone || '+91-XXXXXXXXXX'}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-secondary mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{contactInfo?.registered_address?.en || 'India'}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-500 text-sm">
            © {currentYear} KAPISH CORPORATE RESOLUTION LLP. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <Link to="/legal" className="text-gray-500 hover:text-secondary text-sm transition-colors">
              Legal & Compliance
            </Link>
            <Link to="/contact" className="text-gray-500 hover:text-secondary text-sm transition-colors">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
